var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',[_c('div',{staticClass:"content-container"},[(_vm.showPreCheckList)?_c('check-list',{attrs:{"checkList":_vm.accessDataArr},on:{"refresh":_vm.refresh,"skip":_vm.busiCheck}}):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a8771c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/pages/customerCheck/customerCheck.vue
// module id = 956
// module chunks = 2